import { ComponentProps, useState } from 'react';
import { DimensionValue, StyleProp, StyleSheet, ViewStyle } from 'react-native';
import Modal from 'react-native-modal';

import Colors from '../../constants/Colors';
import { AuthenticateFnParams, useAuthenticate } from '../../contexts/authFlow';
import { useIsLoggedIn } from '../../contexts/authentication';
import useAppNavigation from '../../hooks/useAppNavigation';
import useColorScheme from '../../hooks/useColorScheme';
import { PrimaryButton } from '../Button';
import ModalCloseButton from '../ModalCloseButton';
import { TextBody, TextFinePrint } from '../StyledText';
import { TransparentView, View } from '../Themed';

export default function CTAButton({
  style,
  buttonColor,
  title,
  authenticateParams,
  buttonProps,
}: {
  style?: StyleProp<ViewStyle>;
  buttonColor?: string;
  title?: string;
  authenticateParams?: AuthenticateFnParams;
  buttonProps?: Partial<ComponentProps<typeof PrimaryButton>>;
}) {
  const [alreadyLoggedInModal, setAlreadyLoggedInModal] = useState(false);
  const theme = useColorScheme();
  const authenticate = useAuthenticate();

  const { navigate } = useAppNavigation();

  const hide = () => setAlreadyLoggedInModal(false);

  const isLoggedIn = useIsLoggedIn();

  const onPress = () => {
    if (isLoggedIn) {
      setAlreadyLoggedInModal(true);
      return;
    }
    authenticate(undefined, authenticateParams || { source: 'PAID_AD' });
  };
  return (
    <TransparentView style={[{ alignItems: 'center' }, style]}>
      <PrimaryButton
        style={{
          backgroundColor: buttonColor || Colors[theme].accent,
          paddingHorizontal: 30,
        }}
        title={title || 'Get $50 in Child Care Credit'}
        onPress={onPress}
        {...buttonProps}
      />
      {authenticateParams?.onlyNewJoiners && (
        <TextFinePrint
          bold
          style={{ color: Colors[theme].textLowContrast, marginTop: 8 }}
        >
          *Offer only applies to new accounts created
        </TextFinePrint>
      )}

      <Modal
        useNativeDriver
        style={{ margin: 0 }}
        isVisible={alreadyLoggedInModal}
        onBackdropPress={hide}
        hideModalContentWhileAnimating
        testID="login-modal-container"
      >
        <TransparentView
          style={{ alignItems: 'center', justifyContent: 'center' }}
        >
          <View style={styles.alreadyLoggedInModalWrapper}>
            <ModalCloseButton absolute onPress={hide} />
            <TextBody style={styles.tc}>
              Yay! 🎉 You already have an account with us.
            </TextBody>
            <PrimaryButton
              title="Book Child Care Today"
              style={{ marginTop: 24 }}
              onPress={() => {
                hide();
                navigate('Explore');
              }}
            />
          </View>
        </TransparentView>
      </Modal>
    </TransparentView>
  );
}

const styles = StyleSheet.create({
  tc: { textAlign: 'center' },
  alreadyLoggedInModalWrapper: {
    width: 'calc(100% - 20px)' as DimensionValue,
    maxWidth: 510,
    height: '100%',
    maxHeight: 364,
    borderRadius: 30,
    padding: 40,
    paddingTop: 70,
    position: 'relative',
  },
});
